package ru.it_mozaika.utils


import ru.it_mozaika.sender.common.httpClient.client
import io.ktor.client.plugins.websocket.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import io.ktor.websocket.*
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch


open class Api {

    protected suspend fun get(url: String, parameters: Map<String, Any>? = null): HttpResponse {
        val path = "/api/v1$url"

        val response = client.get(path) {
            parameters?.forEach { (key, value) ->
                parameter(key, value)
            }
//            header(HttpHeaders.)
//            cookies().forEach { println("Cookie get: ${it.name} ${it.value}") }
            header(HttpHeaders.Cookie, document.cookie.trim())
//            parseClientCookiesHeader(document.cookie).forEach {
//                println("cookie: ${it.key} ${it.value}")
//            }
        }
        if (!response.status.isSuccess()) {
            console.warn("GET request to url $path is not success: ${response.status}")
        }
        return response
    }
    protected suspend fun post(url: String, parameters: Map<String, Any>? = null, setBody: HttpRequestBuilder.() -> Unit): HttpResponse {
        val response = client.post(url) {
            contentType(ContentType.Application.Json)
            setBody()
            parameters?.forEach { (key, value) ->
                parameter(key, value)
            }
        }
        if (!response.status.isSuccess()) {
            console.warn("POST request to url $url is not success: ${response.status}")
        }
        return response
    }
    protected suspend fun put(url: String, parameters: Map<String, Any>? = null, setBody: HttpRequestBuilder.() -> Unit): HttpResponse {
        val response = client.put(url) {
            contentType(ContentType.Application.Json)
            setBody()
            parameters?.forEach { (key, value) ->
                parameter(key, value)
            }
        }
        if (!response.status.isSuccess()) {
            console.warn("POST request to url $url is not success: ${response.status}")
        }
        return response
    }
    protected suspend fun patch(url: String, parameters: Map<String, Any>? = null, setBody: HttpRequestBuilder.() -> Unit): HttpResponse {
        val response = client.patch(url) {
            contentType(ContentType.Application.Json)
            setBody()
//            setBody(body)
            parameters?.forEach { (key, value) ->
                parameter(key, value)
            }
        }
        if (!response.status.isSuccess()) {
            console.warn("PATCH request to url $url is not success: ${response.status}")
        }
        return response
    }
    protected suspend fun delete(url: String, parameters: Map<String, Any>? = null): HttpResponse {
        val response = client.delete(url) {
            parameters?.forEach { (key, value) ->
                parameter(key, value)
            }
        }
        if (!response.status.isSuccess()) {
            console.warn("DELETE request to url $url is not success: ${response.status}")
        }
        return response
    }
    protected fun asyncGet(url: String, parameters: Map<String, Any>? = null, callback: suspend (HttpResponse) -> Unit) {
        CoroutineScope(Dispatchers.Default).launch {
            callback(get(url, parameters))
        }
    }
    protected fun asyncPost(url: String, parameters: Map<String, Any>? = null, setBody: HttpRequestBuilder.() -> Unit, callback: suspend (HttpResponse) -> Unit) {
        CoroutineScope(Dispatchers.Default).launch {
            callback(post(url, parameters, setBody))
        }
    }
    protected fun asyncPut(url: String, parameters: Map<String, Any>? = null, setBody: HttpRequestBuilder.() -> Unit, callback: suspend (HttpResponse) -> Unit) {
        CoroutineScope(Dispatchers.Default).launch {
            callback(put(url, parameters, setBody))
        }
    }
    protected fun asyncPatch(url: String, parameters: Map<String, Any>? = null, setBody: HttpRequestBuilder.() -> Unit, callback: suspend (HttpResponse) -> Unit) {
        CoroutineScope(Dispatchers.Default).launch {
            callback(patch(url, parameters, setBody))
        }
    }
    protected fun asyncDelete(url: String, parameters: Map<String, Any>? = null, callback: suspend (HttpResponse) -> Unit) {
        CoroutineScope(Dispatchers.Default).launch {
            callback(delete(url, parameters))
        }
    }

    protected fun ws(url: String, callback: suspend (DefaultWebSocketSession) -> Unit) {
        CoroutineScope(Dispatchers.Default).launch {
            client.ws(url) {
                callback(this)
            }
        }
    }
}